import React, { useState } from "react";

import { PublicClientApplication } from "@azure/msal-browser";
import { loginApiRequest, msalConfig } from "configs/msalConfig";
import { ISignInFederatedRequestModel } from "models/dto/Rocketta/LicenseServer/Models/Auth/ISignInFederatedRequestModel";
import { AuthProviderTypes } from "models/dto/Rocketta/LicenseServer/Utilities/Enums/AuthProviderTypes";
import { AuthApi } from "api/authApi";
import { useAppStore } from "store/index";
import { extractErrorMessage, toErrorMessageBar } from "@helpers/alertUtils";
import { DefaultButton, IStackTokens, mergeStyleSets, Stack, ThemeProvider, useTheme } from "@fluentui/react";
import classNames from "classnames/bind";
import LicenseServerRoutes from "routes";
import { useNavigate } from "react-router-dom";

const containerStackTokens: IStackTokens = { childrenGap: 5 };

export const SignInForm: React.FunctionComponent = () => {
  const { accountStore } = useAppStore();
  const theme = useTheme();
  const signInStyles = mergeStyleSets({
    root: {
      display: "flex",
      width: "100%",
      maxWidth: "400px",
      margin: "auto",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    },
    stack: {
      color: theme.semanticColors.bodyText,
      backgroundColor: theme.semanticColors.bodyBackground,
      border: `1px solid ${theme.semanticColors.buttonBorder}`,
      padding: "20px 20px",
    },
  });
  const cx = classNames.bind(signInStyles);
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const navigate = useNavigate();

  const signInMicrosoft = async (): Promise<void> => {
    const msalInstance = new PublicClientApplication(msalConfig);
    await msalInstance.initialize();
    const popupResult = await msalInstance.loginPopup(loginApiRequest);
    const data: ISignInFederatedRequestModel = {
      authProvider: AuthProviderTypes.Microsoft,
      token: popupResult.accessToken,
    };
    try {
      const signInResponse = await AuthApi.signInFederated(data);
      const token = signInResponse.data.data.accessToken;
      accountStore.signIn(token);
      navigate(LicenseServerRoutes.Home);
    } catch (err) {
      const message = extractErrorMessage(err);
      setErrorMessage(message);
      return err;
    }
  };

  const signUpMicrosoft = async (): Promise<void> => {
    const msalInstance = new PublicClientApplication(msalConfig);
    await msalInstance.initialize();
    const popupResult = await msalInstance.loginPopup(loginApiRequest);
    const data: ISignInFederatedRequestModel = {
      authProvider: AuthProviderTypes.Microsoft,
      token: popupResult.accessToken,
    };
    const signInResponse = await AuthApi.signUpFederated(data);
  };

  return (
    <div className={cx(signInStyles.root, "ui-component")}>
      <Stack verticalAlign="center" className={signInStyles.stack} tokens={containerStackTokens}>
        <img src="/icons/rocketta_icon.svg" alt="*" />
        <h1>Rocketta license server</h1>
        <DefaultButton onClick={signInMicrosoft}>
          <img src="/icons/microsoft_icon.svg" alt="*" />
          Sign In with Microsoft
        </DefaultButton>
        <DefaultButton onClick={signUpMicrosoft}>
          <img src="/icons/microsoft_icon.svg" alt="*" />
          Sign Up with Microsoft
        </DefaultButton>
        {errorMessage && toErrorMessageBar(errorMessage)}
      </Stack>
    </div>
  );
};
